module.exports = __webpack_public_path__ + "static/media/IMG-20190707-WA0008.dbc39d75.jpg";